export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const validateEmail = (email) => {
    if (Array.isArray(email)) {
        let isValid = true;
        email.forEach(item => {
            if (!item || !validateEmail(item)) {
                isValid = false;
            }
        })
        return isValid
    }
    return String(email)
        .toLowerCase()
        .match(
            EMAIL_REGEX
        );
};

export const validateEmailString = (strEmails, char) => {
    if (!char || Array.isArray(strEmails)) {
        return validateEmail(strEmails)
    }

    let arrEmails = strEmails.toString().split(char);
    let isValid = true;
    arrEmails.forEach(item => {
        if (!item || !validateEmail(item)) {
            isValid = false;
        }
    })

    return isValid;
}

export const validatePhone = (phone) => {
    if (Array.isArray(phone)) {
        let invalidPhones = []
        phone.forEach(item => {
            if (item.length < 10 || !(/^\d+$/.test(item))) {
                invalidPhones.push(item)
            }
        })
        return invalidPhones.length === 0
    }
    return phone.length >= 10 && /^\d+$/.test(phone)
};

export const isYear = (year) => {
    const strYear = year.toString().trim()
    return strYear.length === 4 && (/^[0-9]+$/.test(strYear.trim()))
};

export const validatePhoneString = (strPhones, char) => {
    if (!char || Array.isArray(strPhones)) {
        return validatePhone(strPhones)
    }

    let arrPhone = strPhones.toString().split(char);
    let isValid = true;
    arrPhone.forEach(item => {
        if (!item || !validatePhone(item)) {
            isValid = false;
        }
    })

    return isValid;
}

export const autoCorrectStrPhone = (phones, char) => {
    let arrPhone = phones
    if (typeof phones === 'string' || phones instanceof String) {
        arrPhone = phones.toString().split(char);
    }

    arrPhone = arrPhone.map(item => {
        if (!validatePhone(item)) {
            return item.replace(/[^0-9]/g, "")
        }
        return item
    })

    return arrPhone.join(';');
}

export const autoCorrectStrEmail = (emails, char) => {
    let arrEmail = emails
    if (typeof emails === 'string' || emails instanceof String) {
        arrEmail = emails.toString().split(char);
    }

    arrEmail = arrEmail.map(item => {
        if (!validatePhone(item)) {
            return item.replace(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g, "")
        }
        return item
    })

    return arrEmail.join(';');
}